<template>
    <div>
        <loading 
            :active="creating_project || loading_real_estate_type_map"
            :can-cancel="false" 
            :is-full-page="true"
        />

        <valuation-subject-wizard
            v-model="valuation_subject"
            @finish="createProject"
            ref="wizard"
        />
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css';

import ApiService from "@/components/utils/api.service.js"
import { Swal } from "@/components/utils/swal.alerts.js";

import ValuationSubjectWizard from "./ValuationSubjectWizard.vue"
import store from "./store"

export default {
    props: {
        re_key: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            valuation_subject: {
                "project": null,
                "session_list": [],
                "real_estates": [],
            },
            creating_project: false,
            loading_real_estate_type_map: false,
            // re_keys already offered a new analysis, so a repeated rejection cannot loop.
            out_of_range_offered: [],
        }
    },
    components: {
        Loading,
        ValuationSubjectWizard
    },
    methods: {
        createProject: function(valuation_subject) {
            this.creating_project = true;
            return ApiService
                .post(`/amas/project/api/valuation-subject-wizard-create`, valuation_subject)
                .then(response => {
                    this.creating_project = false;
                    window.location.href = `/amas/project/${response.data.task_id}`;
                })
                .catch(error => {
                    this.creating_project = false;
                    const is_403 = error.response && error.response.status === 403;
                    if(is_403 && error.response.data.code === "re_out_of_range") {
                        return this._offerNewAnalysisForRejectedRealEstate(error.response.data);
                    }
                    Swal({
                        title: this.$t("general:warning"),
                        text: is_403
                            ? (error.response.data.detail || error.response.data.details
                                || this.$t("task_details:analysis_failed_please_try_again"))
                            : this.$t("task_details:analysis_failed_please_try_again"),
                        icon: "warning",
                    })
                    if(!is_403) {
                        throw error;
                    }
                })
        },
        _offerNewAnalysisForRejectedRealEstate: function(response_data) {
            /*
            The client-side check can miss a real estate the backend rejects - a location it resolves differently, or a radius that had not loaded yet. Name the offender and offer the same way out the wizard offers: move it into its own analysis and submit again.
            */
            const wizard = this.$refs["wizard"];
            const entry = this.valuation_subject.real_estates
                .find(re => re.re_key === response_data.re_key);
            if(!entry || this.out_of_range_offered.includes(entry.re_key)) {
                Swal({
                    title: this.$t("general:warning"),
                    text: this.$t("task_details:manage:re_out_of_range:description"),
                    icon: "warning",
                })
                return;
            }
            this.out_of_range_offered.push(entry.re_key);
            return Swal({
                title: this.$t("task_details:manage:re_out_of_range"),
                html: wizard._buildOutOfRangeContent(entry.re_key, entry.real_estate),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#2cabe3",
                confirmButtonText: this.$t("task_details:manage:re_out_of_range:start_new_analysis"),
                cancelButtonText: this.$t("general:cancel:btn"),
            }).then(result => {
                if(result.value) {
                    wizard.addRealEstateToSession(entry.id, "new");
                    return this.createProject(this.valuation_subject);
                }
            });
        }
    },
    mounted() {
        const app = this;
        this.loading_real_estate_type_map = true;
        store.dispatch("retrieveRealEstateTypeMap")
        .then(() => {
            app.$refs["wizard"]
                .addRealEstateToSubject(app.re_key, "new")
                .then(_ => {
                    return this.$refs["wizard"].getValuationSubjectEstimation(app.re_key);
                })
                .catch(error => {
                    console.error(error);
                })
        })
        .finally(() => {
            this.loading_real_estate_type_map = false;
        })
    },
}
</script>
